<template>
  <div class="main-home-div">
    <b-jumbotron>
      <template slot="header"> Welcome! </template>
      <template slot="lead"> Setting up your account </template>
      <hr />
      <b-alert show
        >Please wait while we set up your account. You will automatically be
        redirected once your account is ready.</b-alert
      >
    </b-jumbotron>
  </div>
</template>

<script>
import store from "../store";

export default {
  data() {
    return { message: "", attempts: 0, pollingId: null };
  },
  methods: {
    checkUser() {
      store.dispatch("getUser").then(() => {
        var user = store.getters.user;
        this.attempts++;
        this.message +=
          "Attempt #" + this.attempts + " - " + !user.firstTimeUser + "\n";
        // user has been setup
        if (!user.firstTimeUser) {
          this.$router.push({ path: "/" });
        }

        this.pollingId = setInterval(() => {
          store.dispatch("getUser").then(() => {
            var user = store.getters.user;
            this.attempts++;
            this.message +=
              "Attempt #" + this.attempts + " - " + !user.firstTimeUser + "\n";
            // user has been setup
            if (!user.firstTimeUser) {
              //this.$router.push({ path: "/" });
              window.location.reload();
            }
          });
        }, 5000);
      });
    },
  },
  created() {
    this.checkUser();
  },
  beforeDestroy() {
    clearInterval(this.pollingId);
  },
};
</script>

<style>
</style>
